module.exports = svg_8a5061dd08bd629a22e4;